import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-bc3b2748"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "main",
  ref: "sectionMain"
}
const _hoisted_2 = { class: "breadcrumbs" }
const _hoisted_3 = { class: "card" }
const _hoisted_4 = { class: "card-content" }
const _hoisted_5 = { class: "breadcrumb-container-wrapper" }
const _hoisted_6 = { class: "pt-3" }
const _hoisted_7 = { class: "breadcrumb" }
const _hoisted_8 = { class: "card-title-container d-flex pt-4 pb-2" }
const _hoisted_9 = { class: "card-title" }
const _hoisted_10 = { class: "card-ref" }
const _hoisted_11 = { class: "card-subtitle" }
const _hoisted_12 = { class: "mt-3 d-flex gap-3" }
const _hoisted_13 = { class: "d-flex align-items-center gap-1 tag-icon" }
const _hoisted_14 = {
  key: 0,
  class: "values-container"
}
const _hoisted_15 = { class: "value-box" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "value-title" }, [
  /*#__PURE__*/_createElementVNode("span", null, "VGV")
], -1))
const _hoisted_17 = { class: "value-number" }
const _hoisted_18 = { style: {} }
const _hoisted_19 = { class: "value-box" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "value-title" }, [
  /*#__PURE__*/_createElementVNode("span", null, "ROI")
], -1))
const _hoisted_21 = { class: "value-number" }
const _hoisted_22 = { style: {} }
const _hoisted_23 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.breadcrumbs, (item, index) => {
                  return (_openBlock(), _createElementBlock("span", {
                    key: index,
                    class: _normalizeClass({ 'breadcrumb-item': true, 'red': index === _ctx.breadcrumbs.length - 1 })
                  }, _toDisplayString(item), 3))
                }), 128))
              ]),
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.title), 1),
                _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.opportunityRef), 1)
              ]),
              _createElementVNode("div", _hoisted_11, _toDisplayString(_ctx.subtitle), 1)
            ]),
            _createElementVNode("div", _hoisted_12, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tags, (tag, index) => {
                return (_openBlock(), _createElementBlock("div", { key: index }, [
                  _createElementVNode("div", _hoisted_13, [
                    _createElementVNode("i", {
                      class: _normalizeClass(tag.icon)
                    }, null, 2),
                    _createElementVNode("span", null, _toDisplayString(tag.label), 1)
                  ])
                ]))
              }), 128))
            ]),
            (_ctx.vgv && _ctx.roi)
              ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                  _createElementVNode("div", _hoisted_15, [
                    _hoisted_16,
                    _createElementVNode("div", _hoisted_17, [
                      _createElementVNode("span", _hoisted_18, _toDisplayString(_ctx.vgv), 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_19, [
                    _hoisted_20,
                    _createElementVNode("div", _hoisted_21, [
                      _createElementVNode("span", _hoisted_22, _toDisplayString(_ctx.roi), 1)
                    ])
                  ])
                ]))
              : _createCommentVNode("", true)
          ]),
          (_ctx.showHr)
            ? (_openBlock(), _createElementBlock("hr", _hoisted_23))
            : _createCommentVNode("", true)
        ])
      ])
    ])
  ], 512))
}